interface AnchorLinkSelect extends HTMLSelectElement {
	value: string;
}

document.addEventListener('DOMContentLoaded', (): void => {
	const selectElements: NodeListOf<AnchorLinkSelect> = document.querySelectorAll(
		'.block-anchor-links__select'
	);

	selectElements.forEach((select: AnchorLinkSelect): void => {
		select.addEventListener('change', function (this: AnchorLinkSelect): void {
			const selectedUrl: string = this.value;
			if (selectedUrl) {
				window.location.href = selectedUrl;
			}
		});
	});
});
